import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';


// import {
// 	statisticsAction,
// 	statisticsCloseAction
// } from '../../../actions/settingsAction.js';


import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';

import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import { useParams } from "react-router-dom";
const RoleAccessControl = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	const defaultChecked = false;

	const [selectedItems, setSelectedItems] = useState([]);
	const [isChecked, setIsChecked] = useState({ defaultChecked });


	const [checkbox, setCheckbox] = useState([]);

	const history = useHistory();
	const [data, setData] = useState([]);
	// const [leavedetaildata, setLeaveDetailData] = useState([]);
	


	const { search } = useLocation();
	const searchparams = new URLSearchParams(search);
	const param = searchparams.get("id");
	//const handleChange = (e) => setCheckbox(e.target.checked);

  const [leavedet, setLeaveDetail] = useState({
    id: "",
    permission_id: "",
    employee_id: "",
    full_name: "",
    permission_date: "",
    permission_hours: "",
    reason: "",
    applied_on: "",
    status: "",
    remarks: ""
});

	

        const handelInput = (event) => {
            event.preventDefault();
            const { name, value } = event.target;
            console.log(name, value)
            setLeaveDetail({ ...leavedet, [name]: value });
        }





const [permissionList, setPermissionList] = useState([]);
useEffect(() => {
    axios
        .get(API_BASE_URL + '/permission', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("authToken")}`
            }
        })
        .then(res => {
            setPermissionList(res?.data?.data?.table || []);
        })
        .catch(err => {
            toast.error(
                err?.response?.data?.message || "Failed to load permission list",
                {
                    position: "bottom-right",
                    theme: "colored"
                }
            );
        });
}, []);



const handleEditLeaveStatus = (e) => {
    e.preventDefault();

    /* ---------------- BASIC VALIDATION ---------------- */
    if (!leavedet?.status) {
        toast.error("Please select status", {
            position: "bottom-right",
            theme: "colored"
        });
        return;
    }

    if (leavedet.status === "3" && !leavedet.remarks) {
        toast.error("Remarks required for rejection", {
            position: "bottom-right",
            theme: "colored"
        });
        return;
    }

    const emp_id = leavedet?.employee_id;

    /* ---------------- API CALL ---------------- */
    axios.post(
        API_BASE_URL + '/update_permission_status',
        {
            status: leavedet.status,
            remarks: leavedet.remarks,
            permission_id: param,
            id: leavedet.permission_id,
            emp_id: emp_id,
            permission_date: leavedet.permission_date,
            permission_hours: leavedet.permission_hours,
            applied_on: leavedet.applied_on
        },
        {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("authToken")}`
            }
        }
    )
    .then(response => {
        const apiStatus = response?.data?.status;
        const message = response?.data?.message || "Something went wrong";

        /* ---------------- SUCCESS ---------------- */
        if (apiStatus === 'success' || apiStatus === 'sucess') {
            toast.success(message, {
                position: "bottom-right",
                autoClose: 5000,
                theme: "colored"
            });

            setTimeout(() => {
                history.push("Incharge-permission");
            }, 3000);
        }
        /* ---------------- API ERROR ---------------- */
        else {
            toast.error(message, {
                position: "bottom-right",
                autoClose: 5000,
                theme: "colored"
            });
        }
    })
    .catch(error => {
        /* ---------------- NETWORK / SERVER ERROR ---------------- */
        const errMsg =
            error?.response?.data?.message ||
            error?.message ||
            "Server error. Please try again";

        toast.error(errMsg, {
            position: "bottom-right",
            autoClose: 5000,
            theme: "colored"
        });
    });
};



	useEffect(() => {
		axios.get(API_BASE_URL + '/floor_permission_detail_data/' + param, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})

		    // .then(res1 =>console.log(res1.data.leave_detail))
			.then(res1 => setLeaveDetail(res1.data.permission_details))
			.catch(err => console.log(err));
	}, [])


const columns = [
    {
        name: 'Employee',
        selector: row => row['Employee Name'],
        sortable: true
    },
    {
        name: 'Date',
        selector: row => row['Permission Date'],
        sortable: true
    },
    {
        name: 'Hours',
        selector: row => row['Permission Hours'],
        sortable: true
    },
    {
        name: 'Type',
        selector: row => row['Permission Type'],
        sortable: true
    },
    {
        name: 'Reason',
        selector: row => row['Reason'],
        wrap: true
    },
    {
        name: 'Status',
        selector: row => row['Status'],
        sortable: true,
        cell: row => {
            if (row['Status'] === 'Approved')
                return <span className="badge badge-success">Approved</span>;
            if (row['Status'] === 'Rejected')
                return <span className="badge badge-danger">Rejected</span>;
            return <span className="badge badge-warning">Pending</span>;
        }
    }
];


	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />


						</div>
					</div>


					<div className="section-body mt-3">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-4 col-lg-4">
                                <div className="card">
                                    <div className="card-header">
                                        <h5 className="card-title">Permission Detail</h5>
                                    </div>
                                    <div className="card-body">
                                      
                                        <div className="table-responsive">
                                            <table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
                                                    <tbody>
                                                        <tr>
                                                        <th>Employee</th>
                                                        <td>{leavedet.full_name}</td>
                                                        </tr>
                                                        <tr>
                                                        <th>Permission Date</th>
                                                        <td>{leavedet.permission_date}</td>
                                                        </tr>
                                                        <tr>
                                                        <th> permission hour</th>
                                                        <td>{leavedet.permission_hours}</td>
                                                        </tr>
                                                        <tr>
                                                        <th> Reason</th>
                                                        <td>{leavedet.reason}</td>
                                                        </tr>
                                                        <tr>
                                                        <th>Applied On</th>
                                                        <td>{leavedet.applied_on}</td>
                                                        </tr>
                                                        
                                                       
                                        
                                        
                                                    </tbody>
                                            </table>
                                        </div>



                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-8">
                                <form className="card" onSubmit={handleEditLeaveStatus}>
                                    <div className="card-body">
                                        <h3 className="card-title">Update Status</h3>
                                        <div className="row">
                                         
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Status</label>
                                                    <select className="form-control show-tick" name="status" value={leavedet.status} onChange={handelInput}>
                                                    <option value="1" >Pending</option>
                                                    <option value="2" >Approved</option>
                                                    <option value="3" >Rejected</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-12 required-tooltip">
                                                <div className="form-group mb-0">
                                                    <label className="form-label">Remarks</label>
                                                    <textarea rows={5} className="form-control required-input" id="textarea" name="remarks" value={leavedet.remarks}  onChange={handelInput} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    
                      

                                    <div className="card-footer text-left">

                                    <input type="hidden" name="leave_type_id" value={leavedet.leave_type_id} />
                                    <input type="hidden" name="emp_id" value={leavedet.employee_id} />
                                    <input type="hidden" name="diff_days" value={leavedet.diff_days} />
                                    <input type="hidden" name="from_date" value={leavedet.from_date} />
                                    
                                    {leavedet.leave_type_id==1 &&  (
                                    <input type="hidden" name="available_leave" value={leavedet.sick_leave_available} />
                                )}

                                    {(leavedet.leave_type_id==2)||(leavedet.leave_type_id==9) && (
                                    <input type="text" name="available_leave" value={leavedet.leave_available} />
                                )}

                                        <button type="submit" className="btn btn-primary">Save</button>
                                    </div>

                                    {/* {leavedet.status==1 && (

                                   
                                    )} */}
                                </form>
                           
                            </div>




                        </div>
                    </div>

                    </div>




				</div>
			</div>









		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(RoleAccessControl);